import React, { Component } from 'react'
import '../style/ExploreTile.css'
import { Link } from 'react-router-dom';
export class ExploreTile extends Component {

    constructor(){
        super();
        
    }

    render(props) {
        return (
            <Link to={`/explore/${this.props.frog.name.split('#')[1]}`}>
                <div className="explore-tile">
                    {/*<img className="explore-tile-img" src={`https://gateway.pinata.cloud/ipfs/${this.props.frog.image.replace("ipfs://", "")}`} alt="" />*/}
                    <img className="explore-tile-img" src={`https://ipfs.blockfrost.dev/ipfs/${this.props.frog.image.replace("ipfs://", "")}`} alt="" />
                    <span className="explore-tile-span">{this.props.frog.name}</span>
                </div>
            </Link>
        )
    }
}

export default ExploreTile
